<script setup lang="ts">
import * as formatNumber from '@/helpers/numberFormatters'

interface Contacts {
  email?: string
  phone?: string
  whatsapp?: string
  telegram?: string
  instagram?: string
}

defineProps<{
  modelValue: boolean
  contacts: Contacts
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void
}>()

const formatPhone = (value: string) => formatNumber.phone.ru(value)
</script>

<template>
  <v-rich-modal
    :model-value="modelValue"
    title="Контактная информация"
    @update:model-value="() => emit('update:modelValue', false)"
  >
    <div class="teacher-bio__contact-grid">
      <template v-if="contacts.email">
        <span class="teacher-bio__contact-label">Эл. почта</span>
        <v-link :href="`mailto:${contacts.email}`">
          {{ contacts.email }}
        </v-link>
      </template>

      <template v-if="contacts.phone">
        <span class="teacher-bio__contact-label">Телефон</span>
        {{ formatPhone(contacts.phone) }}
      </template>

      <template v-if="contacts.whatsapp">
        <span class="teacher-bio__contact-label">WhatsApp</span>
        <span>
          {{ formatPhone(contacts.whatsapp) }}
          <v-link target="_blank" :href="`https://wa.me/7${contacts.whatsapp}`" class="ml-1" mode="primary">
            <v-icon size="16">mdi-open-in-new</v-icon>
          </v-link>
        </span>
      </template>

      <template v-if="contacts.telegram">
        <span class="teacher-bio__contact-label">Telegram</span>
        <span>
          @{{ contacts.telegram }}
          <v-link target="_blank" :href="`https://t.me/${contacts.telegram}`" class="ml-1" mode="primary">
            <v-icon size="16">mdi-open-in-new</v-icon>
          </v-link>
        </span>
      </template>

      <template v-if="contacts.instagram">
        <span class="teacher-bio__contact-label">Instagram</span>
        <span>
          @{{ contacts.instagram }}
          <v-link target="_blank" :href="`https://instagram.com/${contacts.instagram}`" class="ml-1" mode="primary">
            <v-icon size="16">mdi-open-in-new</v-icon>
          </v-link>
        </span>
      </template>
    </div>
  </v-rich-modal>
</template>
